<template>
  <div class="afterDealPage">
    <div class="tableContent">
      <Table :dataSource="tableData" :columns=columns :pagination="false" rowKey="id" border size="small">
        <template slot="bodyItemName" slot-scope="text, record">
        <span>{{record.body_item_name || record.bodyItemName || record.name}}</span>
        </template>
        <template slot="afterDealButton" slot-scope="text, record">
          <Button style="margin-left:5px;margin-top:5px;" v-if="record.base_element_name || record.name">{{record.base_element_name || record.name}}</Button>
        </template>
      </Table>
    </div>
    <Row>
      <Col :span="16">
        <h3 style="font-weight:bold">AI算法</h3>
        <div class="choiceItem choiceItemleft">
          <Button v-for="(item, index) in afterDealList" :key="index" @click="addItem(item)" style="margin-left:16px;margin-top:5px;" :type="item.checked ? 'primary' : ''">{{item.name}}</Button>
        </div>
      </Col>
      <Col :span="8">
      <h3 style="font-weight:bold">已选算法</h3>
        <div class="choiceItem">
          <Button v-for="(item, index) in choicedItem" :key="index" @click="removeItem(item)" style="margin-left:16px;margin-top:5px;" type="primary">{{item.name || item.base_element_name}}<Icon type="close"/></Button>
        </div>
      </Col>
    </Row>
    <div class="footer">
      <div>
        <Button size="large" @click="closeAfterDeal">取消</Button>
        <Button type="primary" size="large" @click="saveAfterDeal">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button, Table, Icon } from 'ant-design-vue'
import { getAfterDealList } from '../../api/check'
import { filter } from 'lodash'
import { arrayUnqiue } from '../../libs/utils'
export default {
  props: {
    dealTag: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Row,
    Col,
    Button,
    Table,
    Icon
  },
  data () {
    return {
      afterDealList: [],
      choicedItem: [],
      tableData: [],
      columns: [
        {
          title: '检查部位',
          scopedSlots: { customRender: 'bodyItemName' }
        },
        {
          title: 'AI算法',
          scopedSlots: { customRender: 'afterDealButton' }
        },
      ]
    }
  },
  async mounted () {
    this.tableData = filter(this.dealTag, {privateBaseElement: true})
    await this.getDataList()
    this.handleChoicedTag()
     console.log('123', this.choicedItem)
  },
  methods: {
    // 获取后处理标签
    async getDataList () {
      let data = await getAfterDealList({ processType: '10' })
      if (data && data.length > 0) this.afterDealList = data
    },
    // 增加后处理标签
    addItem (item) {
      if (item.checked) return false
      item.checked = true
      item.privateBaseElement = false
      this.choicedItem.push(item)
    },
    // 删除后处理标签
    removeItem (item) {
      item.checked = false
      if (this.choicedItem &&  this.choicedItem.length !== 0) {
        for (let i = 0; i < this.choicedItem.length; i++) {
          if (item.baseElementId) {
            if (item.baseElementId === this.choicedItem[i].baseElementId) {
              this.choicedItem.splice(i, 1)
            }
          } else if (item.id === this.choicedItem[i].id || item.base_element_id === this.choicedItem[i].id) {
            this.choicedItem.splice(i, 1)
          }
        }
      }
      for (let i = 0; i < this.afterDealList.length; i++) {
        let ele = this.afterDealList[i]
        if (ele.id === item.id || ele.id === item.base_element_id) {
          ele.checked = false
        }
        if (item.baseElementId) {
          if (ele.id === item.baseElementId) {
            ele.checked = false
          }
        }
      }
      for (let j = 0; j < this.tableData.length; j++) {
        if (item.baseElementId) {
          if (this.tableData[j].baseElementId === item.baseElementId) {
            this.tableData.splice(j, 1)
          }
        } else if (item.id === this.tableData[j].base_element_id || item.base_element_id === this.tableData[j].base_element_id) {
          this.tableData.splice(j, 1)
        }
      }
    },
    // 处理已经选的的后处理标签
    handleChoicedTag () {
      if (this.dealTag.length !== 0) {
        for (let i = 0; i < this.dealTag.length; i++) {
          if (!this.dealTag[i].base_element_name) {
            this.dealTag[i].base_element_name = this.dealTag[i].name
          }
          // if (this.dealTag[i].baseElementId) {
          //   this.dealTag[i].id = this.dealTag[i].baseElementId
          // }
        }
        this.choicedItem = this.dealTag
        for (let i = 0; i < this.choicedItem.length; i++) {
          if (this.choicedItem[i].base_element_name) {
            this.choicedItem = arrayUnqiue(this.choicedItem, 'base_element_name')
          }
        }
        this.handeleList()
      }
    },
    // 处理列表是否选中
    handeleList () {
      if (this.choicedItem.length !==0 ) {
        for (let i = 0; i < this.choicedItem.length; i++) {
          let item = this.choicedItem[i]
          for (let j = 0; j < this.afterDealList.length; j++) {
            let ele = this.afterDealList[j]
            if (item.base_element_id === ele.id || item.baseElementId === ele.id || item.id === ele.id) {
              ele.checked = true
            }
          }
        }
      }
    },
    // 取消
    closeAfterDeal () {
      this.$emit('closeAfterDeal')
    },
    // 保存后处理标签
    saveAfterDeal () {
      let arr = []
      for (let i = 0; i < this.choicedItem.length; i++) {
        let item = this.choicedItem[i]
        let obj = {}
        obj.id = item.id
        obj.privateBaseElement = item.privateBaseElement
        obj.base_element_name = item.base_element_name ||item.name
        obj.body_item_name = item.body_item_name || item.bodyItemName
        obj.base_element_id = item.base_element_id ||item.baseElementId || item.id
        arr.push(obj)
      }
      this.$emit('newAddAfterDeal', arr)
    }
  }
}
</script>

<style lang="less">
@import '../../style/index.less';
.afterDealPage{
   .tableContent{
      height: 230px;
      overflow-y: auto;
   }
  .choiceItem{
    border:1px solid #d9d9d9;
    height: 130px;
    overflow: auto;
    padding: 5px 0;
    border-radius: 5px;
    overflow-y: auto
  }
  .choiceItemleft{
    margin-right: 5px;
  }
  .footer{
    .modalFooter();
  }
}
@media all and (max-width: 767px){
  .afterDealModal{
    top: 10px;
    .afterDealPage .footer{
      margin: 0;
    }
    .ant-modal-body{
      padding: 8px;
      .afterDealPage{
        .tableContent{
          height: 180px;
        }
        .ant-col-16, .ant-col-8{
          width: 100%;
        }
      }
    }
  }
}
</style>